module.exports = __webpack_public_path__ + "static/Mega-Walk-In-Drive-Popup-Image - Mobile-13b43efc28558e647dd5211e7804777f.png";